<div class="p-4 md:p-6 max-w-full mx-auto">
  <ng-container *ngIf="userRole === userEnum.aguacate_retail_client">
    <ng-container *ngIf="estadoValidacion === 2">
      <!-- Saludo -->
      <div class="mb-6">
        <h1 class="text-lg text-gray-700">Hola, <span class="font-bold text-gray-800">{{user.nombre}}</span></h1>
      </div>

      <!-- Card Tasas del día -->
      <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden mb-6">
        <div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 16px 24px; border-bottom: 2px solid #bbf7d0;">
          <h2 style="margin: 0; font-size: 1rem; font-weight: 700; color: #1e5a3f; display: flex; align-items: center; gap: 8px;">
            <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #1C593D;">show_chart</mat-icon>
            Tasas del día
          </h2>
        </div>
        <div class="p-5">
          <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
            <div *ngFor="let rate of rates" class="bg-gray-50 rounded-xl border border-gray-200 p-4">
              <p style="color: #1e5a3f; font-weight: 700; white-space: nowrap; font-size: 0.9rem;">
                {{ rate.rango.split('-')[0] | currency:'USD':'$':'1.0-0' }} CLP - {{ rate.rango.split('-')[1] | currency:'USD':'$':'1.0-0' }} CLP
              </p>
              <p class="text-sm text-gray-500 mt-1">{{ rate.descripcion }}</p>
              <p style="font-size: 1.1rem; font-weight: 700; color: #1C593D; margin-top: 4px;">Tasa: {{ rate.tasa | number:'1.5-5' }}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Acciones -->
      <h2 style="font-size: 1.15rem; font-weight: 700; color: #1e5a3f; margin-bottom: 16px; display: flex; align-items: center; gap: 8px;">
        <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #1C593D;">rocket_launch</mat-icon>
        ¿Qué deseas realizar hoy?
      </h2>
      <div class="grid grid-cols-2 sm:grid-cols-3 gap-4 mb-6">
        <div routerLink="/retail/exchange"
          style="background: white; border: 2px solid #e5e7eb; border-radius: 16px; padding: 20px 16px; cursor: pointer; transition: all 0.2s ease; display: flex; flex-direction: column; align-items: center; gap: 12px; text-align: center;"
          onmouseover="this.style.borderColor='#1C593D'; this.style.transform='translateY(-3px)'; this.style.boxShadow='0 6px 16px rgba(28,89,61,0.12)'"
          onmouseout="this.style.borderColor='#e5e7eb'; this.style.transform='translateY(0)'; this.style.boxShadow='none'">
          <div style="width: 52px; height: 52px; background: linear-gradient(135deg, #f0fdf4, #ecfdf5); border-radius: 14px; display: flex; align-items: center; justify-content: center; border: 1px solid #bbf7d0;">
            <mat-icon style="font-size: 26px; width: 26px; height: 26px; color: #1C593D;">send</mat-icon>
          </div>
          <span style="font-size: 0.85rem; font-weight: 700; color: #374151;">Enviar Remesa</span>
        </div>
      </div>

      <hr class="border-gray-200 mb-6">
      <app-transactions></app-transactions>
    </ng-container>

    <ng-container *ngIf="estadoValidacion===0">
      <div class="flex flex-col gap-4">
        <button type="button" routerLink="/retail/user-compliance"
          style="display: inline-flex; align-items: center; justify-content: center; gap: 6px; padding: 16px 32px; background: #1C593D; color: white; border: none; border-radius: 12px; font-weight: 700; font-size: 1rem; cursor: pointer; transition: background 0.2s ease; width: fit-content;"
          onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
          Verifica tu cuenta
        </button>
        <span class="px-6 py-4 bg-green-50 rounded-xl border border-green-200 text-gray-700 font-semibold text-sm">
          Para procesar tus envíos es necesario que nos facilites algunos datos personales, esto con el objetivo de hacer tus envíos mas seguros y verificar tu identidad.
        </span>
      </div>
    </ng-container>

    <ng-container *ngIf="estadoValidacion===1">
      <span class="px-6 py-4 bg-green-50 rounded-xl border border-green-200 text-gray-700 font-semibold text-sm block">
        Tu información está siendo validada por nuestro equipo, se te notificará a tu correo electrónico cuando el proceso finalice
      </span>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="userRole === userEnum.aguacate_retail_cashier">
    <!-- Saludo Cajero -->
    <div class="mb-6">
      <h1 class="text-lg text-gray-700">¡Bienvenido(a) al portal de transacciones!</h1>
    </div>

    <!-- Cards Operaciones -->
    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-6">
      <!-- Por procesar -->
      <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden cursor-pointer hover:shadow-lg transition-shadow"
        (click)="redirect('/retail/transactions')">
        <div style="background: linear-gradient(135deg, #fefce8, #fef9c3); padding: 12px 20px; border-bottom: 2px solid #fde68a;">
          <h3 style="margin: 0; font-size: 0.85rem; font-weight: 700; color: #92400e; text-align: center;">
            Operaciones por procesar
          </h3>
        </div>
        <div class="p-4 text-center">
          <div class="inline-block rounded-2xl border-2 border-green-300 p-3 min-w-[120px]">
            <h4 class="text-sm font-bold text-gray-700">AC bolívares</h4>
            <p class="text-2xl font-bold mt-1" [ngClass]="{
              'text-red-600 animate-pulse': this.pendingCount && this.pendingCount?.AC > 30,
              'text-yellow-600': this.pendingCount && this.pendingCount?.AC <= 30 && this.pendingCount?.AC > 15,
              'text-green-700': this.pendingCount && this.pendingCount?.AC <= 15
            }">
              {{this.pendingCount ? this.pendingCount?.AC : 'Cargando'}}
            </p>
            <h5 class="text-xs italic text-gray-500 mt-1">Pendientes</h5>
          </div>
        </div>
      </div>

      <!-- Completadas hoy -->
      <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden cursor-pointer hover:shadow-lg transition-shadow"
        (click)="redirect('/retail/completed-ves-transactions')">
        <div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 12px 20px; border-bottom: 2px solid #bbf7d0;">
          <h3 style="margin: 0; font-size: 0.85rem; font-weight: 700; color: #1e5a3f; text-align: center;">
            Completadas hoy {{ formatDate(todayDate) }}
          </h3>
        </div>
        <div class="p-4 text-center">
          <div class="inline-block rounded-2xl border-2 border-green-300 p-3 min-w-[120px]">
            <h4 class="text-sm font-bold text-gray-700">AC bolívares</h4>
            <p class="text-2xl font-bold text-green-700 mt-1">
              {{this.completedCount?.currentDay ? this.completedCount?.currentDay.AC : 'Cargando'}}
            </p>
            <h5 class="text-xs italic text-gray-500 mt-1">Completadas</h5>
          </div>
        </div>
      </div>

      <!-- Completadas ayer -->
      <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden cursor-pointer hover:shadow-lg transition-shadow"
        (click)="redirect('/retail/completed-ves-transactions')">
        <div style="background: linear-gradient(135deg, #eff6ff, #dbeafe); padding: 12px 20px; border-bottom: 2px solid #93c5fd;">
          <h3 style="margin: 0; font-size: 0.85rem; font-weight: 700; color: #1e3a5f; text-align: center;">
            Completadas ayer {{ formatDate(yesterdayDate) }}
          </h3>
        </div>
        <div class="p-4 text-center">
          <div class="inline-block rounded-2xl border-2 border-green-300 p-3 min-w-[120px]">
            <h4 class="text-sm font-bold text-gray-700">AC bolívares</h4>
            <p class="text-2xl font-bold text-gray-700 mt-1">
              {{this.completedCount?.previousDay ? this.completedCount?.previousDay.AC : 'Cargando'}}
            </p>
            <h5 class="text-xs italic text-gray-500 mt-1">Completadas</h5>
          </div>
        </div>
      </div>
    </div>

    <!-- Card Tasa Web -->
    <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden mb-6" *ngIf="dataCRXT">
      <div style="background: linear-gradient(135deg, #eff6ff, #dbeafe); padding: 16px 24px; border-bottom: 2px solid #93c5fd;">
        <h2 style="margin: 0; font-size: 1rem; font-weight: 700; color: #1e3a5f; display: flex; align-items: center; gap: 8px;">
          <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #1e3a5f;">computer</mat-icon>
          Tasa web del día
        </h2>
      </div>
      <div class="p-5">
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
          <div *ngFor="let tasas of tasas | slice:3:6" class="bg-gray-50 rounded-xl border border-gray-200 p-4 text-center">
            <p style="color: #1e5a3f; font-weight: 700; white-space: nowrap; font-size: 0.9rem;">
              {{ tasas.rango.split('-')[0] | currency:'USD':'$':'1.0-0' }} CLP - {{ tasas.rango.split('-')[1] | currency:'USD':'$':'1.0-0' }} CLP
            </p>
            <p class="text-sm text-gray-500 mt-1">{{ tasas.descripcion }}</p>
            <p style="font-size: 1.1rem; font-weight: 700; color: #1C593D; margin-top: 4px;">Tasa: {{ tasas.tasa | number:'1.5-5' }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Card Tasa Verde -->
    <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden mb-6" *ngIf="dataCRXT">
      <div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 16px 24px; border-bottom: 2px solid #bbf7d0;">
        <h2 style="margin: 0; font-size: 1rem; font-weight: 700; color: #1e5a3f; display: flex; align-items: center; gap: 8px;">
          <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #1C593D;">eco</mat-icon>
          Tasa verde del día
        </h2>
      </div>
      <div class="p-5">
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
          <div *ngFor="let tasas of tasas | slice:0:3" class="bg-gray-50 rounded-xl border border-gray-200 p-4 text-center">
            <p style="color: #1e5a3f; font-weight: 700; white-space: nowrap; font-size: 0.9rem;">
              {{ tasas.rango.split('-')[0] | currency:'USD':'$':'1.0-0' }} CLP - {{ tasas.rango.split('-')[1] | currency:'USD':'$':'1.0-0' }} CLP
            </p>
            <p class="text-sm text-gray-500 mt-1">{{ tasas.descripcion }}</p>
            <p style="font-size: 1.1rem; font-weight: 700; color: #1C593D; margin-top: 4px;">Tasa: {{ tasas.tasa | number:'1.5-5' }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Card Valores Actuales -->
    <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden mb-6">
      <div style="background: linear-gradient(135deg, #fefce8, #fef9c3); padding: 16px 24px; border-bottom: 2px solid #fde68a;">
        <h2 style="margin: 0; font-size: 1rem; font-weight: 700; color: #92400e; display: flex; align-items: center; gap: 8px;">
          <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #92400e;">analytics</mat-icon>
          Valores actuales
        </h2>
      </div>
      <div class="p-5">
        <div class="flex flex-col items-center">
          <h2 *ngIf="!dataCRXT" class="text-lg font-bold text-gray-500">Cargando información...</h2>

          <ng-container *ngIf="dataCRXT">
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-3 w-full max-w-lg mb-4">
              <div class="bg-gray-50 rounded-xl border border-gray-200 p-3 text-center">
                <span class="text-gray-400 text-xs font-semibold uppercase">Tasa USD-CLP</span>
                <p style="font-weight: 700; color: #1C593D; font-size: 1.1rem; margin-top: 4px;">
                  {{ dataCRXT?.clp ? (dataCRXT.clp | number : "1.2-2") : 'Cargando' }}
                </p>
              </div>
              <div class="bg-gray-50 rounded-xl border border-gray-200 p-3 text-center">
                <span class="text-gray-400 text-xs font-semibold uppercase">Tasa CRIXTO</span>
                <p style="font-weight: 700; color: #1C593D; font-size: 1.1rem; margin-top: 4px;">
                  {{ dataCRXT?.rateUsd !== undefined ? (dataCRXT.rateUsd | number : "1.2-5") : 'Cargando' }}
                </p>
              </div>
              <div class="bg-gray-50 rounded-xl border border-gray-200 p-3 text-center">
                <span class="text-gray-400 text-xs font-semibold uppercase">Tasa CBPay</span>
                <p style="font-weight: 700; color: #1C593D; font-size: 1.1rem; margin-top: 4px;">
                  {{ dataCRXT?.rateUsdCBP !== undefined ? (dataCRXT.rateUsdCBP | number : "1.2-5") : 'Cargando' }}
                </p>
              </div>
              <div class="bg-gray-50 rounded-xl border border-gray-200 p-3 text-center">
                <span class="text-gray-400 text-xs font-semibold uppercase">Tasa Manual</span>
                <p style="font-weight: 700; color: #1C593D; font-size: 1.1rem; margin-top: 4px;">
                  {{ dataCRXT?.rateUsdManual !== undefined ? (dataCRXT.rateUsdManual | number : "1.2-5") : 'Cargando' }}
                </p>
              </div>
            </div>

            <!-- Alertas de saldo -->
            <div *ngIf="dataCRXT && !dataCRXT.balanceCXR" class="w-full bg-red-50 border border-red-200 rounded-xl p-3 mb-3 text-center">
              <p class="text-sm text-red-700 font-bold">Se agota el saldo en CRIXTO, informar a administradores.</p>
            </div>
            <div *ngIf="dataCRXT && !dataCRXT.balanceCBP" class="w-full bg-red-50 border border-red-200 rounded-xl p-3 mb-3 text-center">
              <p class="text-sm text-red-700 font-bold">Se agota el saldo en CBPay, informar a administradores.</p>
            </div>

            <!-- Botones acción -->
            <div class="flex flex-wrap justify-center gap-3 mb-4">
              <button type="button" (click)="setRates()"
                style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 24px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
                onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
                <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">update</mat-icon>
                Actualizar tasas
              </button>
              <button type="button" (click)="copiarTasa()"
                style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 24px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 600; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
                onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
                <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #374151;">content_copy</mat-icon>
                Copiar tasa
              </button>
            </div>

            <!-- Toggle tipo tasa -->
            <div class="flex justify-center">
              <mat-button-toggle-group [(ngModel)]="tipoTasa" (change)="onTipoTasaChange()" aria-label="Tipo de Tasa">
                <mat-button-toggle value="CRIXTO">Auto Crixto</mat-button-toggle>
                <mat-button-toggle value="CBPAY">Auto CbPay</mat-button-toggle>
                <mat-button-toggle value="MANUAL">Manual</mat-button-toggle>
              </mat-button-toggle-group>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </ng-container>

  <div *ngIf="hasError" class="bg-red-50 border border-red-200 rounded-xl p-4 text-center">
    <p class="text-red-700 font-bold">No se pudieron cargar los datos. Intenta nuevamente más tarde.</p>
  </div>
</div>
